export const mapConfigurationToFormik = (configuration) => {
  const endClientSummary = configuration.end_client_summary
    ? JSON.parse(configuration.end_client_summary)
    : {};

  return {
    customerId: configuration.customer_id || undefined,
    customClientName: configuration.custom_client_name || "",
    customClientAddress: configuration.custom_client_address || "",
    customClientZipCode: configuration.custom_client_zipcode || "",
    customClientCity: configuration.custom_client_city || "",
    customClientProvince: configuration.custom_client_province || "",
    customClientCountry: configuration.custom_client_country || "Italia",

    // --- End Client ---
    endClientTaxRate: endClientSummary.taxRate ?? 0,
    endClientDownPaymentValue: endClientSummary.downPayment ?? 0,
    endClientDownPaymentType: endClientSummary.downPaymentType ?? "percentage",
    endClientDiscount1: endClientSummary.discount1 ?? 0,
    endClientDiscount2: endClientSummary.discount2 ?? 0,
    endClientNet: endClientSummary.net ?? 0,
    endClientTaxableAmount: endClientSummary.taxableAmount ?? 0,
    endClientTotalTaxes: endClientSummary.totalTaxes ?? 0,
    endClientTotalDiscount: endClientSummary.totalDiscount ?? 0,
    endClientTotal: endClientSummary.total ?? 0,

    // --- Retail (dati dal preventivo attuale) ---
    retailTaxRate: configuration.tax_rate || 0,
    retailDownPaymentType: configuration.down_payment_type || "percentage",
    retailDownPaymentValue: configuration.down_payment || 0,
    retailDiscount1: configuration.discount1 || 0,
    retailDiscount2: configuration.discount2 || 0,
    retailNet: configuration.net || 0,
    retailTaxableAmount: configuration.taxable_amount || 0,
    retailTotalTaxes: configuration.total_taxes || 0,
    retailTotalDiscount: configuration.total_discount || 0,
    retailTotal: configuration.total || 0,

    retailInstallation: configuration.retail_installation || "exclude",
    retailInstallationCosts: configuration.retail_installation_costs || 0,
    retailTransport: configuration.retail_transport || "exclude",

    baseNetPrice: configuration.base_net_price || 0,
    totalServices: configuration.total_services || 0,
    quantity: configuration.qty || 0,
    notes: configuration.notes || undefined,
    isServiceCustomer: true
  };
};
